// App.tsx
import { Facebook, Google, Instagram, LinkedIn, Twitter, Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Link, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { LW_LOGIN_PAGE_BANNER } from '../../constants';

const ClientLogin: React.FC = () => {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [form, setForm] = useState({
        fullName: '',
        email: '',
        password: '',
        termsAccepted: false
    });

    // Handler to toggle password visibility
    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    // Handler for form changes
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, checked, type } = e.target;
        setForm({
            ...form,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // Handle form submission (e.g., call API)
        console.log(form);
    };

    return (
        <Box sx={{ display: 'flex', height: '100vh' }}>
            {/* Left Side */}
            <Box
                sx={{
                    width: { xs: '100%', md: '50%' },
                    // backgroundImage: 'linear-gradient(to right, rgba(63, 81, 181, 0.8) 0%, rgba(0, 0, 0, 1) 100%)',
                    // backgroundSize: '100% 100%', // adjust the size to your liking
                    // backgroundPosition: '0% 0%',
                    // backgroundRepeat: 'no-repeat',
                    color: 'white',
                    p: 4,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Box>
                    <Box display="flex" justifyContent="center" mt={4}>
                        <img
                            src={LW_LOGIN_PAGE_BANNER}
                            alt="Illustration of a person sitting at a desk with a computer and laptop"
                            style={{ maxWidth: '95%' }}
                        />
                    </Box>
                    {/* <Typography variant="h3" fontWeight="bold" mb={4}>
                        Lightworks Services
                    </Typography> */}
                    {/* <Typography variant="h3" fontWeight="bold" mb={4}>
                        Log into your account
                    </Typography> */}
                </Box>
            </Box>

            {/* Right Side */}
            <Box
                sx={{
                    width: { xs: '100%', md: '50%' },
                    p: 4,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Box width="100%" maxWidth="400px">
                    {/* Language Selector */}
                    <Box display="flex" justifyContent="end" mb={2}>
                        <Typography variant="body2" color="textSecondary">
                            English(USA) <IconButton><i className="fas fa-chevron-down"></i></IconButton>
                        </Typography>
                    </Box>
                    <Typography variant="body2" fontWeight="bold" >
                        Bill Buddy
                    </Typography>
                    <Typography variant="h4" fontWeight="bold" mb={3}>
                        Create Account
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        {/* Full Name */}
                        <TextField
                            fullWidth
                            label="Full Name"
                            name="fullName"
                            variant="outlined"
                            margin="normal"
                            value={form.fullName}
                            onChange={handleChange}
                        />

                        {/* Email */}
                        <TextField
                            fullWidth
                            label="Email Address"
                            name="email"
                            type="email"
                            variant="outlined"
                            margin="normal"
                            value={form.email}
                            onChange={handleChange}
                        />

                        {/* Password */}
                        <TextField
                            fullWidth
                            label="Password"
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            variant="outlined"
                            margin="normal"
                            value={form.password}
                            onChange={handleChange}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleTogglePasswordVisibility}>
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        {/* Terms and Conditions */}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="termsAccepted"
                                    checked={form.termsAccepted}
                                    onChange={handleChange}
                                />
                            }
                            label={
                                <Typography variant="body2">
                                    I agree to the{' '}
                                    <Link href="#" underline="hover">
                                        terms of service
                                    </Link>{' '}
                                    and{' '}
                                    <Link href="#" underline="hover">
                                        privacy policy
                                    </Link>
                                </Typography>
                            }
                        />

                        {/* Submit Button */}
                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2, p: 2 }}
                        >
                            Sign Up
                        </Button>
                    </form>

                    <Typography textAlign="center" my={2}>
                        Or Sign Up With
                    </Typography>

                    {/* Social Media Icons */}
                    <Box display="flex" justifyContent="center" gap={2}>
                        <IconButton>
                            <Google />
                        </IconButton>
                        <IconButton>
                            <Facebook />
                        </IconButton>
                        <IconButton>
                            <Instagram />
                        </IconButton>
                        <IconButton>
                            <Twitter />
                        </IconButton>
                        <IconButton>
                            <LinkedIn />
                        </IconButton>
                    </Box>

                    <Box textAlign="center" mt={2}>
                        <Typography variant="body2">
                            Already have an account?{' '}
                            <Link href="#" underline="hover">
                                Sign in
                            </Link>
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export { ClientLogin };

